import { createAction } from 'typesafe-actions';

export const setThemeSpotlightVisited = createAction(
  'SET_THEME_SPOTLIGHT_VISITED'
)<boolean>();

export const setThemeSpotlightExpired = createAction(
  'SET_THEME_SPOTLIGHT_EXPIRED'
)();

export const setNodeLunchSpotlightVisited = createAction(
  'SET_NODE_LUNCH_SPOTLIGHT_VISITED'
)<boolean>();

export const setNodeLunchSpotlightExpired = createAction(
  'SET_NODE_LUNCH_SPOTLIGHT_EXPIRED'
)();

export const setNodeLunchSpotlightIgnored = createAction(
  'SET_NODE_LUNCH_SPOTLIGHT_IGNORED'
)<boolean>();
